import { styled } from '@mui/material';

export const Image = styled('img')(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
  display: 'block',
  flexShrink: 0,
  height: '30px',
  marginRight: theme.spacing(1),
  objectFit: 'cover',
  objectPosition: 'center',
  width: '30px',
}));
